import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";

// Add combo offer
export const addComboOffer = createAsyncThunk(
  "comboOffers/addComboOffer",
  async (formData, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiService.post("/canteen_combo_offers", formData);
      dispatch(getComboOffers());
      return response;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors?.response?.data?.errors || errors.message);
    }
  }
);

// Get all combo offers
export const getComboOffers = createAsyncThunk(
  "comboOffers/getComboOffers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.get("/canteen_combo_offers");
      return response.combo_offer;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors?.response?.data?.errors || errors.message);
    }
  }
);

// Get combo offer by ID
export const getComboOfferById = createAsyncThunk(
  "comboOffers/getComboOfferById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.get(`/canteen_combo_offers/${id}`);
      return response.combo_offer;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors?.response?.data?.errors || errors.message);
    }
  }
);

// Update combo offer
export const updateComboOffer = createAsyncThunk(
  "comboOffers/updateComboOffer",
  async ({ id, formData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiService.patch(`/canteen_combo_offers/${id}`, formData);
      dispatch(getComboOffers());
      return response;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors?.response?.data?.errors || errors.message);
    }
  }
);

// Delete combo offer
export const deleteComboOffer = createAsyncThunk(
  "comboOffers/deleteComboOffer",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiService.delete(`/canteen_combo_offers/${id}`);
      dispatch(getComboOffers());
      return response;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors?.response?.data?.errors || errors.message);
    }
  }
);

const comboOffersSlice = createSlice({
  name: "comboOffers",
  initialState: {
    loading: false,
    success: false,
    error: null,
    comboOffers: [],
    comboOffer: null,
  },
  reducers: {
    resetComboOfferState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.comboOffer = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Add Combo
      .addCase(addComboOffer.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(addComboOffer.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.comboOffer = action.payload;
      })
      .addCase(addComboOffer.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })

      // Get All Combos
      .addCase(getComboOffers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getComboOffers.fulfilled, (state, action) => {
        state.loading = false;
        state.comboOffers = action.payload;
      })
      .addCase(getComboOffers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get Combo by ID
      .addCase(getComboOfferById.pending, (state) => {
        state.loading = true;
        state.comboOffer = null;
      })
      .addCase(getComboOfferById.fulfilled, (state, action) => {
        state.loading = false;
        state.comboOffer = action.payload;
      })
      .addCase(getComboOfferById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Combo
      .addCase(updateComboOffer.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateComboOffer.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.comboOffer = action.payload;
      })
      .addCase(updateComboOffer.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })

      // Delete Combo
      .addCase(deleteComboOffer.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(deleteComboOffer.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(deleteComboOffer.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetComboOfferState } = comboOffersSlice.actions;

export default comboOffersSlice.reducer;
